import { IPAFAddressSite } from 'shared/types/postcodeResults';
import { UpdatePricedQuotePayloadQuote } from 'Quotes/types/actions';
import { IQuote } from 'Quotes/types/store';
import { getDIAChangeSnapshot } from '../Configure/DIAConfig';

interface BuildUpdatePricedQuotePayloadParams {
  quote: IQuote;
  quoteId?: string;
  selectedPriceId: string;
  updateType?: UpdatePricedQuotePayloadQuote['updateType'];
  hotChanges?: Partial<UpdatePricedQuotePayloadQuote>;
  includeDiaSnapshot?: boolean;
}

export const buildUpdatePricedQuotePayload = ({
  quote,
  quoteId,
  selectedPriceId,
  updateType,
  hotChanges,
  includeDiaSnapshot = false,
}: BuildUpdatePricedQuotePayloadParams): UpdatePricedQuotePayloadQuote => {
  const aEndAddress = quote.location.aEnd.fullAddress as IPAFAddressSite;
  const bEndAddress = quote.location.bEnd.fullAddress as IPAFAddressSite;

  const data = {
    id: quoteId ?? '',
    selectedPriceId,

    updateType,

    fttpAggregation: quote.fttpAggregation,
    ddosProtection: quote.ddosProtection,
    cloud_connect_option: quote.cloud_connect_option,

    ...(aEndAddress && aEndAddress.hasChanged && {
      a_end_address_changed: true,
      a_end_uprn: aEndAddress.attributes.uprn ?? '',
      a_end_udprn: aEndAddress.attributes.udprn ?? '',
      a_end_paf_organisation_name: aEndAddress.attributes.organisation_name ?? '',
      a_end_building_name: aEndAddress.attributes.building_name ?? '',
      a_end_building_number: aEndAddress.attributes.building_number ?? '',
      a_end_sub_building: aEndAddress.attributes.sub_building ?? '',
      a_end_full_site_county: aEndAddress.attributes.county ?? '',
      a_end_full_site_town: aEndAddress.attributes.post_town ?? '',
      a_end_full_site_thoroughfare: aEndAddress.attributes.thoroughfare ?? '',
      a_end_openreach_address: null,
      a_end_address_type: quote.location.aEnd.addressType ?? '',
      a_end_colt_building_id: aEndAddress.attributes.colt_building_id ?? '',
    }),
    ...(bEndAddress && bEndAddress.hasChanged && {
      b_end_address_changed: true,
      b_end_uprn: bEndAddress.attributes.uprn ?? '',
      b_end_udprn: bEndAddress.attributes.udprn ?? '',
      b_end_paf_organisation_name: bEndAddress.attributes.organisation_name ?? '',
      b_end_building_name: bEndAddress.attributes.building_name ?? '',
      b_end_building_number: bEndAddress.attributes.building_number ?? '',
      b_end_sub_building: bEndAddress.attributes.sub_building ?? '',
      b_end_full_site_county: bEndAddress.attributes.county ?? '',
      b_end_full_site_town: bEndAddress.attributes.post_town ?? '',
      b_end_full_site_thoroughfare: bEndAddress.attributes.thoroughfare ?? '',
      b_end_openreach_address: null,
      b_end_address_type: quote.location.bEnd.addressType ?? '',
      b_end_colt_building_id: bEndAddress.attributes.colt_building_id ?? '',
    }),
  };

  return {
    ...data,
    ...(includeDiaSnapshot ? getDIAChangeSnapshot(quote.location.aEnd) : {}),
    ...(hotChanges ?? {}),
  };
};
